var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIconOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2569 56.881L49.8079 40.1513C48.8623 39.6781 47.8114 39.4546 46.7551 39.5021C45.6988 39.5496 44.6721 39.8664 43.7728 40.4225C42.8734 40.9785 42.1313 41.7554 41.6168 42.6791C41.1023 43.6029 40.8326 44.6429 40.8334 45.7003V77.2996C40.8326 78.357 41.1023 79.397 41.6168 80.3208C42.1313 81.2445 42.8734 82.0214 43.7728 82.5775C44.6721 83.1335 45.6988 83.4504 46.7551 83.4978C47.8114 83.5453 48.8623 83.3218 49.8079 82.8486L83.2569 66.119C84.1139 65.6894 84.8346 65.0299 85.3382 64.2141C85.8418 63.3984 86.1085 62.4586 86.1085 61.5C86.1085 60.5413 85.8418 59.6015 85.3382 58.7858C84.8346 57.97 84.1139 57.3105 83.2569 56.881Z",
    stroke: "#F8C8CF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 108C87.1812 108 108 87.1812 108 61.5C108 35.8188 87.1812 15 61.5 15C35.8188 15 15 35.8188 15 61.5C15 87.1812 35.8188 108 61.5 108Z",
    stroke: "#F8C8CF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIconOne);
export default __webpack_public_path__ + "static/media/background_icon_one.6bd65678f7ca9c8dac33c4c3ab480496.svg";
export { ForwardRef as ReactComponent };